import { withAuthUser } from 'next-firebase-auth'
import { Stats } from 'views/stats'

export default withAuthUser()(Stats)
